import InputSearch from "./inputsearch";
import ListSurah from "./listsurah";
import { useState } from "react";

function LeftSection({ listSurah, getDetailSurah }) {
  const [search, setSearch] = useState("");
  const [listSurahBaru, setListSurahBaru] = useState([]);

  function onChangeHandler(e) {
    e.preventDefault();
    setSearch(e.target.value);

    if (search.length > 2) {
      const listSurahTemp = listSurah.filter((surah) =>
        surah.nama_latin.toLowerCase().includes(search.toLowerCase())
      );
      setListSurahBaru(listSurahTemp);
    }

    console.log(listSurahBaru);
  }

  return (
    <div className="bg-hijau w-1/2 lg:w-1/4  flex-col flex relative">
      {/* TextField Cari Surah */}
      <InputSearch value={search} onChange={onChangeHandler} />

      {/* List Name Surah */}
      <ListSurah
        listsurah={search.length > 2 ? listSurahBaru : listSurah}
        getDetailSurah={getDetailSurah}
      />
    </div>
  );
}

export default LeftSection;


